import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { LearnspaceMode, Learnspace } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { spaceLabel, StringCase } from '@shared/utils/wording.utils';
@Component({
  selector: 'learnspace-edit-dialog',
  templateUrl: './learnspace-edit-dialog.component.html',
  styleUrls: ['./learnspace-edit-dialog.component.scss']
})
export class LearnspaceEditDialogComponent implements OnInit {
  title: string;
  mode?: LearnspaceMode;
  learnspace?: Learnspace;
  hubId?: string;

  constructor(
    public _dialogRef: MatDialogRef<LearnspaceEditDialogComponent>,
    private _courseApiService: CoursesAPIService,
    @Inject(MAT_DIALOG_DATA) public _data: any, //TODO declare model
  ) {}

  ngOnInit(): void {
    if (this._data) {
      if (this._data.learnspace) {
        this.mode = this._data.learnspace.mode;
        this.title = `${spaceLabel(this.mode, false, StringCase.capitalcase)} Edition`;
        this.learnspace = this._data.learnspace;
      } else {
        this.mode = this._data.mode;
        this.title = `Create a New ${spaceLabel(this.mode, false, StringCase.capitalcase)}`;
        this.hubId = this._data.hubId;
      }
    }
  }
  onLearnspaceChange(ls: Learnspace): void {
    this.learnspace = ls;
  }
  saveAndCloseDialog(): void {
    let query;
    if (this._data && this._data.learnspace) {
      // Update the current object directly to update LS list
      query = this._courseApiService.updateLearnspace(this.learnspace.id, this.learnspace);
    } else {
      const lsData = {
        ...this.learnspace,
        mode: this._data.mode
      };
      query = this._courseApiService.createLearnspace(lsData);
    }
    query.subscribe((ls) => {
      this._dialogRef.close(ls);
    });
  }

  openHelp(): void {
    window.open('https://help.spaces.wondavr.com/en/articles/2491421-create-and-edit-a-team-space');
  }
}
